

export default function split_chunks(num, chunks, i = 0) {

    const rest = ((num * 1000) % (chunks[i] * 1000)) / 1000
    //  console.log('NUM : ' + num, 'chunk : ',chunks[i], 'REST : ' + rest, 'I : ' + i);

    let deep = [];
    if (rest != 0 && i < chunks.length-1) {
        deep = split_chunks(rest, chunks, i+1)
    }

    if (rest != 0 && i == chunks.length-1) {
        return [{ dose: chunks[i], qta : Math.ceil(num/chunks[i])}]
    }

    let ret = []

    if (num >= chunks[i]) {
        ret = [{ dose: chunks[i], qta : parseInt(num/chunks[i])}]
    }

    return  [...ret, ...deep]
}